export const APP_SETTINGS = {
    LOCATIONS:{
        KIOSK_REFRESH : {
            MILLISEC_PER_HOUR : 3600000,
            DO_NOT_REFRESH_KIOSK_VALUE : "Do Not Refresh",
            DEFAULT_KIOSK_REFRESH_RATE : 12 * 3600000
        }

    },
}